export const REGISTER_USER = 'REGISTER_USER';
export const GET_USER = 'GET_USER';
export const SET_USER = 'SET_USER';
export const SET_FILTER = 'SET_FILTER';
export const ADD_REVIEW = 'ADD_REVIEW';
export const GET_REVIEW = 'GET_REVIEW';
export const GET_HOTEL_LIST = 'GET_HOTEL_LIST';
export const SET_BLOCKED_ROOMS = 'SET_BLOCKED_ROOMS';
export const GET_ROOM_LIST = 'GET_ROOM_LIST';
export const SET_ROOM_SELECTION = 'SET_ROOM_SELECTION';
export const SET_LOADING = 'SET_LOADING';
export const SHOW_ALERT = 'SHOW_ALERT';
export const SHOW_AUTH_MODAL = 'SHOW_AUTH_MODAL';
export const CLOSE_AUTH_MODAL = 'CLOSE_AUTH_MODAL';
// export const SET_ROOM_SELECTION = 'SET_ROOM_SELECTION';
